import type { MapId } from "../content/setup.js";
import type { ConflictEvent } from "../types.js";
import type { HostMessage } from "./host-protocol.js";

const initialLobby = {
  townName: "Ember Works",
  aiCount: 2,
  mapId: "ring",
  durationPreset: "lunch-shift",
  clockSpeed: 2,
  botPersonality: "seeded-mix",
  botDifficulty: "foreman",
} as const;
const initialDrafts = {
  construction: { target: "mining-rig", quantity: "1", repeat: false },
  restoration: { target: "mining-rig", quantity: "1", repeat: false },
  assembly: { target: "guard-robot", quantity: "1", repeat: false },
};
export const initialMilitaryDraft = {
  units: { "guard-robot": "0", "raider-robot": "0", "siege-gun": "0" },
  desired: { "guard-robot": "25", "raider-robot": "0", "siege-gun": "0" },
};

export interface CommandFeedback {
  readonly requestId: string;
  readonly targetId: string;
  readonly state: "pending" | "success" | "failure";
  readonly message: string;
}

export function settledCommandFeedback(
  current: CommandFeedback | undefined,
  message: Extract<HostMessage, { readonly kind: "command-result" | "command-error" }>,
): CommandFeedback | undefined {
  if (!message.feedbackId || message.feedbackId !== current?.requestId) return undefined;
  return {
    requestId: message.feedbackId,
    targetId: current.targetId,
    state: message.kind === "command-result" ? "success" : "failure",
    message: message.kind === "command-result" ? "Action accepted." : message.message,
  };
}

export const initialValleyDraft = {
  target: "",
  pactMessage: "",
  shipmentAmount: "10",
  chatMessage: "",
  importArtifact: "",
};

export const initialAppState = {
  phase: "loading",
  lobby: initialLobby,
  workerOwned: false,
  drafts: initialDrafts,
  militaryDraft: {},
  events: [],
  logFilter: "all",
  valleyDraft: initialValleyDraft,
  chat: [],
  replayActive: false,
  paused: false,
} as const;

export function appendEvents(
  current: readonly ConflictEvent[],
  incoming: readonly ConflictEvent[],
): readonly ConflictEvent[] {
  const bySequence = new Map(current.map((event) => [event.sequence, event]));
  for (const event of incoming) bySequence.set(event.sequence, event);
  return [...bySequence.values()]
    .sort((left, right) => Number(left.sequence - right.sequence))
    .slice(-2_000);
}

export function availableMaps(aiCount: number): readonly MapId[] {
  if (aiCount === 1) return ["duel"];
  return aiCount === 5 ? ["ring", "crossroads"] : ["ring"];
}
